import React, { ReactElement, useEffect } from 'react'
import useSelector from '@hooks/use-selector'
import { AppDispatch } from '@types'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { getTaxCategories } from '@store/actions/tax-categories'
import { selectTaxCategories } from '@store/selectors/tax-categories'
import { useDispatch } from 'react-redux'

type Props = {
  value: number | '' | undefined | null
  onChange: (value: number) => void
  disabled?: boolean
  className?: string
  formControlProps?: Record<any, any>
}

const TaxCategorySelect = ({
  value,
  onChange,
  disabled = false,
  formControlProps,
  ...selectProps
}: Props): ReactElement => {
  const dispatch = useDispatch<AppDispatch>()
  const taxCategories = useSelector(selectTaxCategories)

  useEffect(() => {
    if (!taxCategories.length) {
      dispatch(getTaxCategories())
    }
  }, [])

  const handleOnChange = ({ target: { value } }: SelectChangeEvent<number>) =>
    onChange(value as number)

  return (
    <FormControl {...formControlProps}>
      <InputLabel id='netsuite-account-label'>Tax Category</InputLabel>
      {taxCategories && (
        <Select
          disabled={disabled}
          id='tax-cat-select'
          label='Tax Category'
          labelId='tax-category-label'
          onChange={handleOnChange}
          value={value || ''}
          {...selectProps}
        >
          {taxCategories.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  )
}

export default TaxCategorySelect
